import { render } from "./CheckBox.vue?vue&type=template&id=2fd26b32&ts=true"
import script from "./CheckBox.ts?vue&type=script&lang=ts&external"
export * from "./CheckBox.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__